import { render } from "./MobileProposalVotes.vue?vue&type=template&id=7d2b371d"
import script from "./MobileProposalVotes.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileProposalVotes.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/governance/MobileProposalVotes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d2b371d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d2b371d', __exports__)) {
    api.reload('7d2b371d', __exports__)
  }
  
  module.hot.accept("./MobileProposalVotes.vue?vue&type=template&id=7d2b371d", () => {
    api.rerender('7d2b371d', render)
  })

}


export default __exports__